import React from 'react';

import WalletIcon from 'components/basic/icons/WalletIcon';
import MenuLink from 'components/layout/header/MenuLink';
import { staticDispatch, useSelector } from 'reduxState/store';
import { showWalletModal } from 'reduxState/wallet/walletDetailsReducer';

import { MenuItemType } from '../headerTypes';

function UserEmailMenuItem() {
  const loggedIn = useSelector(state => state.currentUser.loggedIn);
  const isCatchAllUser = useSelector(state => state.currentUser.isCatchAllUser);
  const walletAddress = useSelector(state => state.wallet.walletAddress);

  if (!loggedIn || isCatchAllUser) {
    return null;
  }

  return (
    <div style={{ width: '100%' }}>
      {!walletAddress && (
        <MenuLink
          title="Connect Wallet"
          icon={<WalletIcon size={20} />}
          iconSize="20px"
          isTopMenu={false}
          isDropdownItem
          onClick={() => staticDispatch(showWalletModal())}
        />
      )}
    </div>
  );
}

const userEmailItem: MenuItemType = {
  type: 'MenuBox',
  Component: UserEmailMenuItem,
};

export default userEmailItem;
